"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var TextJustify;
(function (TextJustify) {
    TextJustify[TextJustify["Left"] = 0] = "Left";
    TextJustify[TextJustify["Right"] = 1] = "Right";
    TextJustify[TextJustify["Center"] = 2] = "Center";
})(TextJustify = exports.TextJustify || (exports.TextJustify = {}));
var TextDocument = (function (_super) {
    tslib_1.__extends(TextDocument, _super);
    function TextDocument(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(TextDocument.prototype, "fontName", {
        get: function () {
            return this._rawData.f;
        },
        set: function (name) {
            this._rawData.f = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "fontColor", {
        get: function () {
            return this._rawData.fc;
        },
        set: function (color) {
            this._rawData.fc = color;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "fontSize", {
        get: function () {
            return this._rawData.s;
        },
        set: function (size) {
            this._rawData.s = size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "lineHeight", {
        get: function () {
            return this._rawData.lh;
        },
        set: function (lh) {
            this._rawData.lh = lh;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "boxSize", {
        get: function () {
            return this._rawData.sz;
        },
        set: function (size) {
            this._rawData.sz = size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "text", {
        get: function () {
            return this._rawData.t;
        },
        set: function (text) {
            this._rawData.t = text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextDocument.prototype, "textJustify", {
        get: function () {
            return this._rawData.j;
        },
        set: function (justification) {
            this._rawData.j = justification;
        },
        enumerable: true,
        configurable: true
    });
    return TextDocument;
}(AnimationObject_1.AnimationObject));
exports.TextDocument = TextDocument;
//# sourceMappingURL=TextDocument.js.map